<template>
  <div class="p-2 md:p-0"> 
    <dl
      class="border rounded uk-description-list uk-description-list-divider mb-4"
      v-if="notes.length > 0"
    >
      <div class="p-2 border-b" v-for="note in notes">
        <dd style="white-space: pre-wrap" v-html="note.body"></dd>
        <div style="clear: both"></div>
        <span style="float: right; font-size: 9px">
          <vk-icon icon="user" ratio="0.5" />
          {{ note.agent_name }} /
          <small style="font-size: 9px" class="font-semibold text-black">{{
            note.created_at | dateFormat
          }}</small>
        </span>
        <div style="clear: both"></div>
      </div>
    </dl>

    <form @submit.prevent="saveNoteForm()">
      <div class="border rounded-lg mt-4 p-2">
        <div><h2 class="text-lg">Yeni Not</h2></div>
        <div class="uk-margin">
          <textarea
            class="uk-textarea"
            placeholder="Notunuzu buraya girebilirsiniz."
            style="min-height: 100px"
            v-model="noteForm.body"
          ></textarea>

          <div class="multiselect-agents">
            <multiselect
              v-model="noteForm.agents"
              v-if="$root.cache.getOptions[15]"
              :options="$root.cache.getOptions[15]"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Temsilciler"
              label="label"
              track-by="label"
              :preselect-first="true"
            ></multiselect>
          </div>
        </div>

        <div class="uk-margin">
          <label>
            <input
              type="checkbox"
              class="uk-checkbox"
              value="1"
              v-model="noteForm.notification"
              true-value="1"
              false-value="0"
            />
            Bana Hatırlat
          </label>
        </div>
        <template v-if="noteForm.notification == 1">
          <div class="uk-margin">
            <select
              v-model="noteForm.minute"
              @change="minuteConvert(noteForm.minute)"
              class="uk-select"
            >
              <option value="15">15 dakika sonra</option>
              <option value="30">30 dakika sonra</option>
              <option value="60">1 saat sonra</option>
              <option :value="3 * 60">3 saat sonra</option>
              <option :value="24 * 60">24 saat sonra</option>
              <option :value="7 * 60 * 24">1 hafta sonra </option>
              <option :value="14 * 60 * 24">2 hafta sonra </option>
              <option :value="30 * 60 * 24">1 ay sonra</option>
              <option value="c">Özel değer</option>
            </select>
          </div>
          <div class="uk-margin" v-if="noteForm.minute == 'c'">
            <datepicker
              :input="{ name: 'datepicker' }"
              :form="{ type: 1 }"
              @changed="(re) => setDatepickerNote(re)"
            />
          </div>
        </template>
        <div class="uk-margin">
          <savebutton action="saveNoteForm" title="Gönder" />
        </div>
      </div>
      <div style="clear: both"></div>
    </form>
    <form
      @submit.prevent="saveActivityForm()"
      class="border rounded-lg mt-4 p-2"
    >
      <div><h2 class="text-lg">Yeni Etkinlik</h2></div>
      <div class="">
        <div class="uk-margin">
          <select class="uk-select" v-model="activityForm.body"
            ><option value="Telefon Araması Planlandı"
              >Telefon Araması Planlandı</option
            ></select
          >
        </div>

        <div class="uk-margin">
          <div class="multiselect-agents">
            <multiselect
              v-model="activityForm.agents"
              v-if="$root.cache.getOptions[15]"
              :options="$root.cache.getOptions[15]"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Temsilciler"
              label="label"
              track-by="label"
              :preselect-first="true"
            ></multiselect>
          </div>
        </div>

        <div class="uk-margin">
          <label>
            <input
              type="checkbox"
              class="uk-checkbox"
              value="1"
              v-model="activityForm.notification"
              true-value="1"
              false-value="0"
            />
            Bana Hatırlat
          </label>
        </div>
        <template v-if="activityForm.notification == 1">
          <div class="uk-margin">
            <select
              v-model="activityForm.minute"
              @change="minuteConvert(activityForm.minute)"
              class="uk-select"
            >
              <option value="15">15 dakika sonra</option>
              <option value="30">30 dakika sonra</option>
              <option value="60">1 saat sonra</option>
              <option :value="3 * 60">3 saat sonra</option>
              <option :value="24 * 60">24 saat sonra</option>
              <option :value="7 * 60 * 24">1 hafta sonra </option>
              <option :value="14 * 60 * 24">2 hafta sonra </option>
              <option :value="30 * 60 * 24">1 ay sonra</option>
              <option value="c">Özel değer</option>
            </select>
          </div>
          <div class="uk-margin" v-if="activityForm.minute == 'c'">
            <datepicker
              :input="{ name: 'datepicker' }"
              :form="{ type: 1 }"
              @changed="(re) => setDatepickerActivity(re)"
            />
          </div>
        </template>
        <div class="uk-margin">
          <savebutton action="saveactivityForm" title="Gönder" />
        </div>
      </div>
      <div style="clear: both"></div>
    </form>

    <dl
        class="border rounded uk-description-list uk-description-list-divider mb-4"
        v-if="notifications.length > 0"
      >
        <div :key="ntfy.id" class="p-2 border-b" v-for="ntfy in notifications">
          <div class="flex justify-between">
            <dd
              style="white-space: pre-wrap"
              class="font-medium"
              v-html="ntfy.body"
            ></dd>

            <span style=" font-size: 9px">
              <vk-icon icon="user" ratio="0.5" />
              {{ ntfy.agent_name }}
            </span>
          </div>
          <div style="clear: both"></div>

          <div class="flex   space-x-2" style="font-size:9px">
            <div class="border-r pr-2 flex">
              <div>Oluşturulma Tarihi :</div>
              <small style="font-size: 9px" class="font-semibold text-black">{{
                ntfy.created_at | dateFormat
              }}</small>
            </div>
            <div class="flex">
              <div>Bildirim Tarihi :</div>
              <small style="font-size: 9px" class="font-semibold text-black">{{
                ntfy.start | dateFormat
              }}</small>
            </div> <div class="">
              
            
            </div>
          </div>
          <div style="clear: both"></div>

          <div class="flex    pt-2 text-xs space-x-2" v-if="ntfy.title !== 'Platform Girişi'"> 
          <div v-if="ntfy.completed == 0"
          @click="completeNotification(ntfy.id)"
           class="rounded cursor-pointer text-xs border border-green-400 space-x-1 px-2 text-green-500
           inline-flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24"><path fill="currentColor" d="m9.55 15.15l8.475-8.475q.3-.3.7-.3t.7.3t.3.713t-.3.712l-9.175 9.2q-.3.3-.7.3t-.7-.3L4.55 13q-.3-.3-.288-.712t.313-.713t.713-.3t.712.3z"/></svg>
            
       
            <span >Tamamla</span> 
              </div>   
               <div v-if="ntfy.completed == 1"  class="rounded    text-xs border border-green-400 space-x-1 px-2 text-green-500
           inline-flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24"><path fill="currentColor" d="m9.55 15.15l8.475-8.475q.3-.3.7-.3t.7.3t.3.713t-.3.712l-9.175 9.2q-.3.3-.7.3t-.7-.3L4.55 13q-.3-.3-.288-.712t.313-.713t.713-.3t.712.3z"/></svg>
            
       
            <span >Tamamlandı</span>  
              </div> <div v-if="ntfy.completed == 2"  
              class="rounded text-xs border border-red-400 space-x-1 px-2 text-red-500
           inline-flex items-center justify-center">


           <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" viewBox="0 0 14 14"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="m11 9l2-.5l.5 2"/><path d="M13 8.5A6.6 6.6 0 0 1 7 13h0a6 6 0 0 1-5.64-3.95M3 5l-2 .5l-.5-2"/><path d="M1 5.5A6.79 6.79 0 0 1 7 1h0a6 6 0 0 1 5.64 4M7 3.5v4"/><circle cx="7" cy="10" r=".5"/></g></svg>

          
            <span >Gecikmiş</span>       
              </div>
              <span v-if="ntfy.completed_agent_name" style=" font-size: 9px">
              <vk-icon icon="user" ratio="0.5" />
              {{ ntfy.completed_agent_name }}
            </span>
 

        </div>
        </div>
      </dl>
       
  </div>
</template>

<script>
import HttpService from "../../services/http";

import Multiselect from "vue-multiselect";
import dateVue from "../Ui/Search/datetime.vue";
import moment from "moment";
import EventBus from "../Ui/EventBus";
export default {
  props: {
    field: String,
    table: String,
    id: String,
    selectedStatus: String,
  },
  components: {
    multiselect: Multiselect,
    datepicker: dateVue,
  },
  filters: {
    dateFormat(val, type) {
      moment.locale("tr");
      return moment(val, type).format("DD MMMM YYYY, HH:mm");
    },
  },
  data() {
    return {
      notes: [],
      noteStatuses: [],
      notifications: [],
      activityForm: {
        quality: 5,
        body: "Telefon Araması Planlandı",
        notification: 1,
        agents: [
          {
            label: localStorage.getItem("userName"),
            value: localStorage.getItem("userId"),
          },
        ],
      },
      noteForm: {
        quality: 5,
        notification: null,

        agents: [
          {
            label: localStorage.getItem("userName"),
            value: localStorage.getItem("userId"),
          },
        ],
      },

      options: this.$root.cache.getOptions,
    };
  },
  methods: {
    minuteConvert(e) {
      this.noteForm.start = moment()
        .add(e, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
      this.activityForm.start = moment()
        .add(e, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");
    },
    setDatepickerActivity(e) {
      this.activityForm.start = e.value;
      this.activityForm.end = e.value;

      this.$forceUpdate();
    },
    setDatepickerNote(e) {
      this.noteForm.start = e.value;
      this.noteForm.end = e.value;

      this.$forceUpdate();
    },
    getVal(optionKey, value) {
      if (value) {
        return this.$root.cache.getOptions[optionKey].find(
          (e) => e.value == value
        ).label;
      } else {
        return "-";
      }
    },
    completeNotification(id){

      HttpService.completeNotification(id).then(e => {
        this.getData();
      });
    },

    saveNoteForm() {
      if (this.noteForm.body) {
        this.$parent.$emit("loading", true);
        EventBus.$emit("loadingStatus", {
          action: "saveNoteForm",
          loading: true,
        });

        HttpService.inlineSave({
          table: "lead_notes",
          type: "insert_note",
          inputs: this.noteForm,
        })
          .then((resp) => {
            if (resp.data.success) {
              EventBus.$emit("loadingStatus", {
                action: "saveNoteForm",
                loading: false,
                success: true,
              });

              this.edit = false;
              this.noteForm = {};
              this.noteForm = {
                quality: 5,
                notification: null,
                body: null,
                agents: [
                  {
                    label: localStorage.getItem("userName"),
                    value: localStorage.getItem("userId"),
                  },
                ],
              };
              document.querySelector(".uk-textarea").innerHTML = "";
              this.getData();
              this.$root.successMessage("Not başarıyla kaydedildi");
              this.$emit("after", "success");
            } else {
              EventBus.$emit("loadingStatus", {
                action: "saveNoteForm",
                loading: false,
                success: false,
              });
            }
          })
          .catch(() => {
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
            EventBus.$emit("loadingStatus", {
              action: "saveNoteForm",
              loading: false,
              success: false,
            });
          })
          .finally(() => {
            this.$parent.$emit("loading", false);
          });
      } else {
        this.$root.errorMessage("Not içeriği zorunludur");
      }
    },
    saveActivityForm() {
      if (this.activityForm.body) {
        this.$parent.$emit("loading", true);
        EventBus.$emit("loadingStatus", {
          action: "saveactivityForm",
          loading: true,
        });

        HttpService.inlineSave({
          table: "lead_notes",
          type: "insert_note",
          inputs: this.activityForm,
        })
          .then((resp) => {
            if (resp.data.success) {
              EventBus.$emit("loadingStatus", {
                action: "saveactivityForm",
                loading: false,
                success: true,
              });

              this.edit = false;
              this.activityForm = {};
              this.activityForm = {
                quality: 5, 
        body: "Telefon Araması Planlandı",
                notification: null, 
                agents: [
                  {
                    label: localStorage.getItem("userName"),
                    value: localStorage.getItem("userId"),
                  },
                ],
              };
              document.querySelector(".uk-textarea").innerHTML = "";
              this.getData();
              this.$root.successMessage("Not başarıyla kaydedildi");
              this.$emit("after", "success");
            } else {
              EventBus.$emit("loadingStatus", {
                action: "saveactivityForm",
                loading: false,
                success: false,
              });
            }
          })
          .catch(() => {
            this.$root.errorMessage(
              "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
            );
            EventBus.$emit("loadingStatus", {
              action: "saveactivityForm",
              loading: false,
              success: false,
            });
          })
          .finally(() => {
            this.$parent.$emit("loading", false);
          });
      }
    },
    getData() {
      HttpService.detailTable({
        table: "lead_note_statuses",
      }).then((response) => {
        this.noteStatuses = response.data.results;
      });

      this.noteForm.lead_id = this.id;
      this.activityForm.lead_id = this.id;



     

      HttpService.notes({
        table: "notifications",
        field: "lead_id",
        id: this.id,
      }).then((response) => {
        this.notifications = response.data.results; 
      });
      

      HttpService.notes({
        table: "lead_notes",
        field: "lead_id",
        id: this.id,
      }).then((response) => {
        this.notes = response.data.results;
        this.$emit("notSayisi", this.notes.length);
      });

    },
  },
  mounted() {
    EventBus.$on("getNote", () => {
      this.getData();
    });
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.note-statu-icons .active {
  background: #eee !important;
}

.uk-description-list {
  max-height: 500px;
  overflow-y: scroll;
}

.multiselect-agents .multiselect__tags {
  border-color: #ccc;
  margin-top: 10px;
}
</style>
